import { registerCustomBlockType } from "../../utils/restrict-block-register";
import metadata from "./block.json";
import Edit from "./Edit";
import Save from "./save";

registerCustomBlockType(
  {
    ...metadata,
    edit: Edit,
    save: Save,
    icon: {
      foreground: "#0061FE",
      src: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="24" height="24" fill="none" />
          <path d="M20.1699 19.0928C20.5841 19.0928 20.9199 19.4286 20.9199 19.8428C20.9197 20.2568 20.584 20.5928 20.1699 20.5928H3.75C3.33616 20.5925 3.00026 20.2566 3 19.8428C3 19.4287 3.33599 19.093 3.75 19.0928H20.1699Z" />
          <path d="M17.126 11.3359C17.54 11.3361 17.8759 11.6719 17.876 12.0859L17.875 13.9102H19.7559C20.1698 13.9103 20.5057 14.2461 20.5059 14.6602C20.5057 15.0741 20.1698 15.4099 19.7559 15.4102H17.875V17.3477C17.8748 17.7616 17.539 18.0976 17.125 18.0977C16.7111 18.0974 16.3751 17.7616 16.375 17.3477V15.4102H14.4951C14.081 15.4101 13.7452 15.0743 13.7451 14.6602C13.7455 14.2463 14.0812 13.9112 14.4951 13.9111L16.375 13.9102L16.376 12.0859C16.3762 11.672 16.712 11.3361 17.126 11.3359Z" />
          <path d="M11.0488 13.8945C11.4628 13.8948 11.7988 14.2305 11.7988 14.6445C11.7988 15.0586 11.4628 15.3943 11.0488 15.3945H3.75C3.33599 15.3943 3 15.0586 3 14.6445C3 14.2305 3.33599 13.8948 3.75 13.8945H11.0488Z" />
          <path d="M20.1699 8.69727C20.5841 8.69727 20.9199 9.03305 20.9199 9.44727C20.9199 9.86148 20.5841 10.1973 20.1699 10.1973H3.75C3.33599 10.197 3 9.86133 3 9.44727C3 9.0332 3.33599 8.69751 3.75 8.69727H20.1699Z" />
          <path d="M20.1699 3.5C20.5841 3.5 20.9199 3.83579 20.9199 4.25C20.9197 4.66399 20.584 5 20.1699 5H3.75C3.33616 4.99976 3.00026 4.66384 3 4.25C3 3.83594 3.33599 3.50024 3.75 3.5H20.1699Z" />
        </svg>
      ),
    },
  },
  {
    removeAncestorInTemplates: ["single-product"],
  }
);
